module.exports = __webpack_public_path__ + "static/media/html.fa6f3660.png";